<template>
  <div>
    <b-form-row>
      <b-col class="mb-2">
        <b-button @click="showDesembolsos" size="sm" variant="success"
          ><i class="fas fa-sync"></i> Atualizar Lista</b-button
        >
        <b-button class="ml-2" @click="deleteAll" size="sm" variant="danger"
          ><i class="fas fa-sync"></i> Excluir Tudo</b-button
        >

        <b-button
          @click="doAddDesembolso()"
          class="float-right"
          size="sm"
          variant="success"
          ><i class="fas fa-plus"></i> Adicionar</b-button
        >
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-table
          hover
          bordered
          small
          responsive
          striped
          foot-clone
          primary-key="desembolso_id"
          table-class="font08 table-border"
          thead-class="table-header"
          selectable
          select-mode="single"
          selected-variant="primary"
          head-variant="dark"
          empty-text="Sem dados para exibir"
          empty-filtered-text="Sem dados para exibir"
          show-empty
          :fields="campos"
          :items="desembolsos"
        >
          <template v-slot:cell(mes)="data">
            {{ `${String(data.item.mes).padStart(2, "0")}/${data.item.ano}` }}
          </template>
          <template v-slot:cell(acoes)="data">
            <b-button
              size="sm"
              variant="primary"
              @click="editDesembolso(data.item)"
              title="Alterar"
              ><i class="fas fa-edit"></i
            ></b-button>
            <b-button
              size="sm"
              variant="danger"
              @click="deleteDesembolso(data.item)"
              title="Excluir"
              ><i class="fas fa-trash"></i
            ></b-button>
            <b-button
            
              size="sm"
              variant="secondary"
              @click="showObsDesembolso(data.item)"
              title="Ver Observações"
              ><i class="far fa-comments"></i
            ></b-button>
          </template>
          <template v-slot:foot(mes)
            ><span>TOTAL</span></template
          >
          <template v-slot:foot(nr_documento)
            ><span></span></template
          >
          <template v-slot:foot(cotacao)
            ><span></span></template
          >
          <template v-slot:foot(acoes)
            ><span></span></template
          >

          <template v-slot:foot(vl_desembolso)
            ><span>{{ getTotalDesembolso }}</span></template
          >
          <template v-slot:foot(vl_desembolso_m2)
            ><span>{{ getTotalDesembolsoM2 }}</span></template
          >
        </b-table>
      </b-col>
    </b-form-row>
    <b-modal
      title="Observações"
      id="modal-obs-desembolso"
      no-close-on-backdrop
      no-close-on-esc
      no-fade
      size="lg"
    >
      <b-form-row>
        <b-col>
          <b-form-textarea
            size="sm"
            disabled
            :value="desembolso.observacoes"
            rows="20"
            no-resize
          ></b-form-textarea>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button
          size="sm"
          @click="() => $bvModal.hide('modal-obs-desembolso')"
          >Fechar</b-button
        >
      </template>
    </b-modal>
    <ModalDesembolso
      :registro="desembolso"
      :acao="acaoDesembolso"
      @updateDesembolsos="showDesembolsos"
    />
  </div>
</template>

<script>
import { formatMoney } from "@/global";
import moment from "moment";

import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import ModalDesembolso from "./ModalDesembolso";

const desembolsoModel = () => {
  return {
    desembolso_id: 0,
    mes_ano: moment().format("M") + "/" + moment().format("Y"),
    nr_documento: "",
    vl_desembolso: 0,
    vl_desembolso_m2: 0,
    cotacao: 0,
    observacoes: "",
  };
};

export default {
  name: "SubTabDesembolsos",
  components: { ModalDesembolso },
  computed: {
    getTotalDesembolso: function() {
      let valor = this.desembolsos.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_desembolso);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalDesembolsoM2: function() {
      let valor = this.desembolsos.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_desembolso_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },

  },
  props: {
    programa: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  data: function() {
    return {
      desembolso: new desembolsoModel(),
      acaoDesembolso: "alterar",
      desembolsos: [],
      campos: [
        {
          key: "mes",
          label: "Mês/Ano",
        },
        {
          key: "nr_documento",
          label: "Nº Documento",
        },
        {
          key: "vl_desembolso",
          class: "text-right",
          label: "Valor do Desembolso",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "cotacao",
          class: "text-right",
          label: "Cotação 2ª Moeda",
          formatter: (val) => {
            return formatMoney(val, 4, "", ".", ",");
          },
        },
        {
          key: "vl_desembolso_m2",
          class: "text-right",
          label: "Valor Desembolso M2",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        { key: "acoes", label: "Ações" },
      ],
    };
  },
  methods: {
    deleteAll() {
      this.$bvModal
        .msgBoxConfirm(`Excluir todos os Desembolsos?`, {
          noFade: true,
          okTitle: "Excluir",
          cancelTitle: "Cancelar",
          buttonSize: "sm",
          footerClass: "confirm-dialog",
        })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(
                `${baseApiUrl}/bid/desembolsos/${this.programa.programa_id}`
              )
              .then(() => {
                this.showDesembolsos();
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    doAddDesembolso() {
      this.desembolso = new desembolsoModel();
      this.desembolso.programa_id = this.programa.programa_id;
      this.desembolso.cotacao = 1;
      this.desembolso.vl_desembolso = 0;
      this.desembolso.vl_desembolso_m2 = 0;
      this.desembolso.mes_ano = moment().format("MM/YYYY");
      this.desembolso.nr_documento = "";
      this.desembolso.observacoes = "";
      this.acaoDesembolso = "incluir";
      this.$bvModal.show("modal-desembolso");
    },
    showObsDesembolso(item) {
      this.desembolso = { ...item };
      this.$bvModal.show("modal-obs-desembolso");
    },
    editDesembolso(item) {
      this.desembolso = { ...item };
      this.desembolso.mes_ano = `${String(this.desembolso.mes).padStart(2, "0")}/${this.desembolso.ano}`;
      this.acaoDesembolso = "alterar";
      this.$bvModal.show("modal-desembolso");
    },
    deleteDesembolso(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Excluir o Desembolso [${item.desembolso_id}]?`,
          {
            noFade: true,
            okTitle: "Excluir",
            cancelTitle: "Cancelar",
            buttonSize: "sm",
            footerClass: "confirm-dialog",
          }
        )
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(
                `${baseApiUrl}/bid/desembolsos/${item.desembolso_id}`
              )
              .then(() => {
                this.showDesembolsos();
              })
              .catch((err) => {
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    showDesembolsos() {
      //this.desembolsos = this.programa.desembolsos;
      this.refreshDesembolsos();
    },
    refreshDesembolsos() {
      axios
        .get(`${baseApiUrl}/bid/desembolsos/listar`, {
          params: {
            programa_id: this.programa.programa_id
          },
        })
        .then((resp) => {
          this.desembolsos = resp.data;
        })
        .catch((ex) => {
          showError(ex);
        });
    },
  },
  mounted() {
    this.showDesembolsos();
  },
};
</script>

<style>
.top-header th {
  background-color: #4c545b !important;
  text-align: center;
  border-bottom: none !important;
}

.table-header th {
  border-color: #aaa !important;
}

.accum-col {
  background-color: #efefef;
}

.accum-col:hover {
  color: #333 !important;
}

.table-border td {
  border-color: #ccc !important;
}
</style>
